export default {
  ACCOUNT_OPEN_WAIT_HEADING: "Your investment application has been submitted.",
  ACCOUNT_OPEN_WAIT_SUBHEADING:
    "Return to this screen shortly to receive an update.",
  ACCOUNT_OPEN_WAIT_BUTTON_HEADING: "Check Status",

  LANDING_HEADING: "Welcome to Bright Investment Advisors",
  LANDING_SUBHEADING: "Let's open the account.",

  NEXT: "Next",
  CONTINUE: "Continue",

  LOGIN_HEADING: "Welcome to Bright Investment Advisors.",
  LOGIN_SUBHEADING: "What’s your phone number?",
  LOGIN_SUBHEADING_2: "Log in or open an account.",
  LOGIN_DETAILS:
    "To verify you’re a human we’ll send you a one-time text message with a code.",
  LOGIN_PHONE: "Phone Number",
  LOGIN_GET_STARTED: "Continue",
  LOGIN_ERROR: "Please enter valid Phone Number.",

  OTP_HEADING: "Enter your verification code",
  OTP_SUBHEADING: (value) => `We sent the code to ${value}`,
  OTP_SUBHEADING_2: "Enter your one time code.",
  OTP_ERROR: "Please enter valid OTP.",

  NAME_HEADING: "What is your name?",
  NAME_DETAILS:
    "I agree to Bright’s Terms of Use, E-Sign Consent and ACH Authorization. By clicking the Continue button, I understand that I’m providing written instructions in accordance with the FCRA, authorizing Bright Capital to obtain my credit information from Equifax. I hereby authorize Bright Capital to access my personal credit information in order to display my credit data to me and for Bright Capital to present me with financial insights, recommendations and relevant offers. This will have NO impact on my credit report.",
  FIRST_NAME: "First Name",
  LAST_NAME: "Last Name",
  FIRST_NAME_ERROR_MESSAGE: "Please enter valid first name",
  LAST_NAME_ERROR_MESSAGE: "Please enter valid last name",

  DOB_HEADING: "When were you born?",
  DOB: "Date of birth: MM/DD/YYYY",
  DOB_PLACEHOLDER: "MM/DD/YYYY",
  DOB_ERROR_MESSAGE: "Please enter valid date",

  ADDRESS_HEADING: "Where do you live?",
  ADDRESS_STREET: "Street Address",
  ADDRESS_APARTMENT: "Apartment (Optional)",
  ADDRESS_CITY: "City",
  ADDRESS_STATE: "State",
  ADDRESS_ZIP: "Zip Code",
  ADDRESS_STREET_ERROR_MESSAGE: "Please enter valid street address",
  ADDRESS_APARTMENT_ERROR_MESSAGE: "Please enter valid apartment",
  ADDRESS_CITY_ERROR_MESSAGE: "Please enter valid city",
  ADDRESS_STATE_ERROR_MESSAGE: "Please enter valid state",
  ADDRESS_ZIP_ERROR_MESSAGE: "Please enter valid zip code",

  SSN_HEADING: "What is your social security number?",
  SSN: "Social Security Number",
  SSN_ERROR_MESSAGE: "Please enter valid social security number",
  SSN_PLACEHOLDER: "XXX-XX-XXXX",

  BANKING_INFO_HEADING: "Enter the details of your funding account and amount.",
  BANKING_INFO_SUBHEADING:
    "Enter your account number and routing number to fund your account.",
  BANKING_INFO_ACCOUNT_NUMBER: "Account Number",
  BANKING_INFO_ROUTING_NUMBER: "Routing Number",
  BANKING_INFO_INVEST: "How much money would you like to invest?",
  ACCOUNT_NUMBER_ERROR_MESSAGE: "Please enter valid account number.",
  ROUTING_NUMBER_ERROR_MESSAGE: "Please enter valid routing number.",
  INVEST_AMOUNT_ERROR_MESSAGE: "Please enter valid amount.",

  EMAIL_HEADING: "What's your email address?",
  EMAIL: "Email",
  EMAIL_ERROR_MESSAGE: "Please enter valid email address",

  NETWORK_HEADING: "Network Error",
  NETWORK_SUBHEADING: "Please login again after some time.",
  RETRY: 'Retry'
};
